import { Divider, Skeleton, Stack, Typography } from "@mui/material";
import LockIcon from "@entrilia/shared/icons/LockIcon";
import PanelSection from "../../../../../common/layout/PanelSection";
import PanelSectionHeader from "../../../../../common/layout/PanelSectionHeader";
import { LockedInvestorPortalPopover } from "../../../common/LockedPortalPagePopovers";
import PortalAccessFooter from "./PortalAccessFooter";
import PortalAccessRow from "./PortalAccessRow";

interface Props {
  subtitle?: string;
  companyTitle: string;
}

const lockedRows = [
  { label: "Access", valueWidth: 150, actionWidth: 96 },
  { label: "Contacted", valueWidth: 170, actionWidth: 110 },
  { label: "Registration", valueWidth: 150, actionWidth: 100 },
];

const LockedPortalAccessSection = ({ subtitle, companyTitle }: Props) => (
  <PanelSection>
    <PanelSectionHeader title="Portal Access" subtitle={subtitle}>
      <LockedInvestorPortalPopover />
    </PanelSectionHeader>
    <Stack divider={<Divider />}>
      <Stack component="dl" divider={<Divider />} sx={{ m: 0 }}>
        {[...lockedRows, { label: `Active at ${companyTitle}`, valueWidth: 120, actionWidth: 96 }].map((row) => (
          <PortalAccessRow
            key={row.label}
            label={row.label}
            value={<Skeleton animation={false} variant="rounded" height={12} width={row.valueWidth} />}
            actions={<Skeleton animation={false} variant="rounded" height={24} width={row.actionWidth} />}
          />
        ))}
      </Stack>
      <PortalAccessFooter>
        <LockIcon color="secondary" />
        <Typography variant="caption" color="textPrimary" sx={{ flex: 1 }}>
          See who has access, who&apos;s registered and who&apos;s active for every contact — and invite, reset
          passwords and impersonate from one place. Available with the Investor Portal add-on.
        </Typography>
      </PortalAccessFooter>
    </Stack>
  </PanelSection>
);

export default LockedPortalAccessSection;
